import { ReactNode } from 'react'

import { typography } from '@joor/design-system'
import styled from 'styled-components'

import { EMPTY_CELL_CONTENT } from 'shop/products/utils'

const Title = styled.div`
  ${typography.alpha.primaryActive.body2}
  line-height: 16px;
  color: var(--color-primary-400);
`

const Content = styled.div`
  ${typography.alpha.primaryActive.subtitle3}
  line-height: 16px;
`

export type DetailsItem = {
  title: string
  content: ReactNode
  testId?: string
}

export const DetailsListItem = ({ title, content, testId }: DetailsItem) => (
  <div>
    <Title>{title}</Title>
    <Content data-testid={testId} className="notranslate">
      {content || EMPTY_CELL_CONTENT}
    </Content>
  </div>
)
